function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0857 7.59006V15.6537C21.0857 16.0244 20.6887 16.349 20.3143 16.2247L16.4572 15.047V8.19679C16.4572 8.19679 20.3121 7.01967 20.3143 7.01898C20.6832 6.90635 21.0857 7.19833 21.0857 7.59006Z",
  fill: "#00A94F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7847 5.14285H4.31819C3.35498 5.14285 2.57144 5.89029 2.57144 6.80914V16.4366C2.57144 17.3554 3.35498 18.1029 4.31819 18.1029H13.7847C14.7479 18.1029 15.5314 17.3554 15.5314 16.4366V6.80914C15.5314 5.89029 14.7479 5.14285 13.7847 5.14285ZM8.73732 9.03085H5.13914C4.81761 9.03085 4.55694 8.78214 4.55694 8.47542C4.55694 8.1687 4.81761 7.92 5.13914 7.92H8.73732C9.05885 7.92 9.31959 8.1687 9.31959 8.47542C9.31959 8.78214 9.05885 9.03085 8.73732 9.03085Z",
  fill: "#00A94F"
});

function SvgVdoCallMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdoCallMb);
export default __webpack_public_path__ + "static/media/vdo_call_mb.4fceea7d.svg";
export { ForwardRef as ReactComponent };